var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactivePieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.05103V11H21.949C21.479 6.28302 17.717 2.52103 13 2.05103ZM17.969 20.004C20.158 18.367 21.663 15.864 21.949 13H13.766L17.969 20.004Z",
    fill: "#757576"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12V2.05103C5.954 2.55503 2 6.82402 2 12C2 17.514 6.486 22 12 22C13.4723 21.9981 14.9257 21.6688 16.255 21.036C16.255 21.036 11.002 12.121 11.001 12.005C11.0009 12.0033 11.0005 12.0016 11 12Z",
    fill: "#757576"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivePieChart);
export default __webpack_public_path__ + "static/media/inactive-pie-chart.edf33220d2eb1f181f2fc8f5cfd9c991.svg";
export { ForwardRef as ReactComponent };